<div class="master">

  <div class="header">
    <div>
      <ng-content select=[left]></ng-content>
    </div>
    <div>
      <ng-content select=[right]></ng-content>
    </div>
  </div>

  <div class="toolbar">
    <div class="diff-count">
      @switch (diffCount)
        {
        @case (null) {
          <span>Comparing...</span>
        }
        @case (0) {
          <span class="green">No differences</span>
        }
        @default {
          <span class="red">{{ diffCount }} difference{{ diffCount === 1 ? '' : 's' }}</span>
        }
      }
    </div>
    <div>
      <label id="language">Language</label>
      <select [(ngModel)]="language">
        @for (item of languages; track item) {
          <option [ngValue]="item.id">{{item.name}}</option>
        }
      </select>
    </div>
    <div>
      <label id="render">Render</label>
      <select [(ngModel)]="sideBySide">
        @for (item of sideBySideOptions; track item) {
          <option [ngValue]="item.id">{{item.name}}</option>
        }
      </select>
    </div>
  </div>

  <ngx-monaco-diff-editor class="monaco" [options]="diffOptions" [originalModel]="originalModel" [modifiedModel]="modifiedModel">
  </ngx-monaco-diff-editor>
</div>
